import * as React from "react";
import { InputWithAlert } from "../ui/input-with-alert";
import { formatDateString } from "@/styles";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { useQuery, useQueryClient } from "react-query";
import { toast } from "../ui/use-toast";
import {
  approveClientDocument,
  denyClientDocument,
  getUser,
} from "@/service/weexpertService";
import { ROLES } from "@/constants";

export const DocumentDostempDoRynkuPracy = (props) => {
  const { document } = props;
  const { entityType, createdAt, status, validFrom, validTo, uniqueId } =
    document;
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { data: user, isLoading } = useQuery({
    queryKey: "userMe",
    queryFn: getUser,
    retry: false,
  });
  return (
    <div className="w-full">
      <div className="pt-6">
        <InputWithAlert
          label={t("document_type")}
          disabled={true}
          type="text"
          value={entityType}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("created_at")}
          disabled={true}
          type="text"
          value={formatDateString(createdAt)}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("status")}
          disabled={true}
          type="text"
          value={status}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("unique_id")}
          disabled={true}
          type="text"
          value={uniqueId ? uniqueId : t("not_specified")}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("valid_from")}
          disabled={true}
          type="text"
          value={format(new Date(validFrom), "dd.MM.yyyy")}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("valid_to")}
          disabled={true}
          type="text"
          value={format(new Date(validTo), "dd.MM.yyyy")}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      {user.data.roles === ROLES.SUPER_ADMIN && (
        <div className="pt-6 justify-end content-end items-end w-full  flex">
          <Button
            className="mr-4 text-blueText bg-blueLightAccent hover:bg-blueLightAccent border-[1px] border-blueBorder shadow-none"
            onClick={() => {
              denyClientDocument(document.id)
                .then((res) => {
                  toast({
                    title: "Success",
                  });
                })
                .catch((err) => {
                  toast({
                    title: "Error",
                    variant: "destructive",
                  });
                })
                .finally(() => {
                  queryClient.invalidateQueries(["document"]);
                });
            }}
          >
            Deny
          </Button>
          <Button
            className=""
            onClick={() => {
              approveClientDocument(document.id)
                .then((res) => {
                  toast({
                    title: "Success",
                  });
                })
                .catch((err) => {
                  toast({
                    title: "Error",
                    variant: "destructive",
                  });
                })
                .finally(() => {
                  queryClient.invalidateQueries(["document"]);
                });
            }}
          >
            Approve
          </Button>
        </div>
      )}
    </div>
  );
};
